import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { PurchaseOrderLine } from 'src/app/models/purchase-order-line';
import { Article } from 'src/app/models/article';
import { SapArticle } from 'src/app/models/sap-article';
import { Supplier } from 'src/app/models/supplier';
import { Unity } from 'src/app/models/unity';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ArticleService } from 'src/app/services/article.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { UnityService } from 'src/app/services/unity.service';
import { RequisitionService } from 'src/app/services/requisition.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { Requisition } from 'src/app/models/requisition';
import { RequisitionLine } from 'src/app/models/requisition-line';
import { environment } from 'src/environments/environment';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { RequisitionSap } from 'src/app/models/requisition-sap';

@Component({
  selector: 'app-purchase-order-create',
  templateUrl: './purchase-order-create.component.html',
  styleUrls: ['./purchase-order-create.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PurchaseOrderCreateComponent implements OnInit {
  actualUser:string = "";
  order:PurchaseOrder = new PurchaseOrder();
  orderLine:PurchaseOrderLine = new PurchaseOrderLine();

  articles:Article[] = [];
  article:Article = null;
  suppliers:Supplier[] = [];
  supplier:Supplier = null;
  unities:Unity[] = [];
  unity:Unity = null;
  customers:Customer[] = [];
  customer:Customer = null;

  requisitions:Requisition[] = [];

  articlesSAP:SapArticle[] = [];

  loading:boolean = false;

  canCreateOrder:boolean = false;

  isSap:boolean = false;

  constructor( private auth:AuthService, private toastr:ToastrManager, private articleServ:ArticleService, private supplierServ:SupplierService, private unityServ:UnityService, private modal:NgbModal, private requisitionServ:RequisitionService, private utl:UtilitiesService, private orderServ:PurchaseOrderService, private customerServ:CustomerService ) { }

  ngOnInit() {
    let user = this.auth.getActualUser();
    this.actualUser = `${user.name} ${user.last_name}`;

    this.canCreateOrder = this.auth.can('store-purhcase-order');

    this.loading = true;
    this.articleServ.getArticles().then(articles => {
      this.articles = articles;
      this.article = this.articles[0];
    });
    this.supplierServ.getSuppliers().then(suppliers => {
      this.suppliers = suppliers;
      this.supplier = this.suppliers[0];
    });
    this.unityServ.getUnities().then(unities => {
      this.unities = unities;
      this.unity = this.unities[0];
      this.loading = false;
    });
    this.customerServ.getCustomers('Compañia').then(customers => {
      this.customers = customers;
      this.customer = customers[0];
    });
  }

  getTotal() {
    return this.order.lines.filter(ln => ln.status != 'Cancelado').map(ln => ln.quantity * ln.unit_price * (ln.iva*1 + 1)).reduce((act, ant) => act + ant, 0);
  }

  openModal(m, req = false) {
    if (req) {
      this.modal.open(m, { size: 'lg', windowClass: 'bigger-max' });
      if (this.requisitions.length == 0) {
        this.loadRequisitions();
      }
    } else {
      this.modal.open(m);
    }
  }

  selectArticle() {
    this.orderLine.article_id = this.article.id;
    this.orderLine.article_name = this.article.name;
    this.orderLine.measure_unit = this.article.measure_unit;
    this.orderLine.warehouse_measure_unit = this.article.warehouse_measure_unit;
    this.orderLine.warehouse_factor = this.article.warehouse_factor;
  }

  save() {

    this.order.supplier_id = this.supplier ? this.supplier.id : null;
    this.order.supplier_name = this.supplier ? this.supplier.business_name : null;

    if (!this.validateLines()) {
      this.toastr.infoToastr("Todas las líneas deben ser de la misma empresa de transportes!");
      return;
    }

    this.loading = true;
    
    this.order.lines.map(line=>{//Cambiar el id de las lineas en 0, para poder crear la orden de compra.
      line.id = 0;
      return line;
    });
    this.orderServ.postPurchaseOrder(this.order).then(order => {
      this.order = new PurchaseOrder();
      this.toastr.successToastr(`Orden de Compra creada con el número ${order.id}`);
      this.loadRequisitions();
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e));
      this.loading = false;
    });
  }

  saveRequisition(){
    this.loading = true;
    //Crear requisicion en SAP
    this.requisitionServ.postRequisitionSap(this.packageRequisition()).then(resp=>{
      this.toastr.successToastr('Se creo la solicitud de compra en SAP: '+resp.correct);
      this.modal.dismissAll();
      this.save();
    }).catch(resp=>{
      if(resp.error.requisition)this.toastr.errorToastr(resp.error.requisition);
      if(resp.error.unity)this.toastr.errorToastr(resp.error.unity);
      if(resp.error.article)this.toastr.errorToastr(resp.error.article);
      if(resp.error.user)this.toastr.errorToastr(resp.error.user);
      if(resp.error.sap)this.toastr.errorToastr(resp.error.sap);
      this.loading = false;
    });

  }

  packageRequisition(){
    let requisition = new RequisitionSap();
    requisition.docDate = new Date();
    requisition.docDueDate = this.order.delivery_date;
    requisition.comment = this.order.description;
    let lines = [];
    this.order.lines.forEach(line=>{
      lines.push({
        itemCode: line.item_code_sap,
        itemName: line.item_name_sap,
        quantity: line.quantity,
        uomEntry: '',
        uomName: '',
        taxCode: 'IVA16C',
        projectCode: '',

        line_id: line.id,
      });
    });
    requisition.lines = lines;
    return requisition;
  }

  selectCustomer() {
    this.orderLine.customer_id = this.customer ? this.customer.id : null;
    this.orderLine.customer_name = this.customer ? this.customer.name : null;
  }

  selectUnity() {
    this.orderLine.unity_id = this.unity ? this.unity.id : null;
    this.orderLine.unity = this.unity ? this.unity.unit_type.name + ' ' + this.unity.brand + ' ' + this.unity.model : null;
    this.orderLine.unity_detail = this.unity ? this.unityInfo(this.unity) : null;
    this.orderLine.customer_id = this.unity ? this.unity.customer.id : null;
    this.orderLine.customer_name = this.unity ? this.unity.customer.name : null;
  }

  addline() {
    if(this.orderLine.comments.trim() != "")
    {
      if (this.orderLine.article_id && this.orderLine.quantity && this.orderLine.customer_id && this.orderLine.unit_price) {
        this.order.lines.push(Object.assign({}, this.orderLine));
        this.orderLine = new PurchaseOrderLine();
      } else { this.toastr.infoToastr("El artículo, la cantidad, la empresa y el precio son campos obligatorios!"); }
    }else{ this.toastr.infoToastr('Debes agregar comentarios a la partida'); }
  }

  loadRequisitions() {
    this.loading = true;
    this.requisitionServ.getOpenRequisitions().then(requisitions => {
      this.requisitions = requisitions.filter(r => r.authorized);
      this.loading = false;
    });
  }

  loadArticlesSap(){
    this.loading = true;
    this.articleServ.getArticlesSap('NMH_PROD').then(articles => {
      this.articlesSAP = articles;
      this.loading = false;
    });
  }

  changeArticleSap(itemCode, id){
    let article = this.articlesSAP.findIndex(art=> art.itemCode == itemCode);
    let index = this.order.lines.findIndex(lin=> lin.id == id);
    this.order.lines[index].item_code_sap = this.articlesSAP[article].itemCode;
    this.order.lines[index].item_name_sap = this.articlesSAP[article].itemName;
  }

  validateLines() {
    for (let i = 0; i < this.order.lines.length; i++) {
      let ln = this.order.lines[i];
      if (ln.customer_id != this.order.lines[0].customer_id) {
        return false;
      }
    }

    return true;
  }

  selectRequisitions() {
    for(let i = 0; i < this.requisitions.length; i++) {
      let selectedLinesTmp = this.requisitions[i].lines.filter(line => line.selected);
      for (let j = 0; j < selectedLinesTmp.length; j++) {
        if (!this.order.lines.find(ln => ln.requisition_line_id == selectedLinesTmp[j].id)) {
          if(this.canSelectRequisition(selectedLinesTmp[j])){
            this.order.lines.push({
              article_id: selectedLinesTmp[j].article_id,
              article_name: selectedLinesTmp[j].article_name,
              id: selectedLinesTmp[j].id,//tomar el id de la requisicion para poder emparejar la busqueda de los articulos de SAP.
              iva: selectedLinesTmp[j].iva,
              purchase_order_id: 0,
              quantity: selectedLinesTmp[j].missing_quantity,
              requisition_line_id: selectedLinesTmp[j].id,
              requisition_id: this.requisitions[i].id,
              selected: true,
              status: 'Abierto',
              unit_price: selectedLinesTmp[j].unit_price,
              unity_id: selectedLinesTmp[j].unity_id,
              description: selectedLinesTmp[j].description,
              customer_id: selectedLinesTmp[j].customer_id,
              customer_name: selectedLinesTmp[j].customer_name,
              measure_unit: selectedLinesTmp[j].measure_unit,
              discount: 0,
              warehouse_factor: selectedLinesTmp[j].warehouse_factor,
              warehouse_measure_unit: selectedLinesTmp[j].warehouse_measure_unit,
              unity: selectedLinesTmp[j].unity,
              unity_detail: 'No Serie: ' + selectedLinesTmp[j].unity_serial_num + ' | No Chasis: ' + selectedLinesTmp[j].unity_chassis_serial_num + ' | No Motor: ' + selectedLinesTmp[j].unity_engine_serial_num,
              missing_quantity: 0,
              is_sap: selectedLinesTmp[j].is_sap,
              item_code_sap: selectedLinesTmp[j].item_code_sap,
              item_name_sap: selectedLinesTmp[j].item_name_sap,
              comments: selectedLinesTmp[j].comments
            });
          }else{
            this.toastr.infoToastr("No se pudieron agregar las lineas, no pertenecen al mismo dato de SAP("+selectedLinesTmp[j].is_sap+")");
          }
        }
      }
    }
  }

  canSelectRequisition(requisitionLine:RequisitionLine){
    return (this.order.lines.length == 0)? true : this.order.lines[0].is_sap == requisitionLine.is_sap;
  }

  unityInfo(u:Unity) {
    return 'No Serie: ' + u.serial_num + ' | No Chasis: ' + u.chassis_serial_num + ' | No Motor: ' + u.engine_serial_num;
  }

  removeLine(line:PurchaseOrderLine) {
    this.order.lines = this.order.lines.filter(l => l != line);
  }
}
